import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGateValue } from '@statsig/react-bindings';

interface RequireMocksGateProps {
  children: React.ReactNode;
}

/**
 * Route-level guard for sections marked `mocked: true` in the settings
 * registry. When `feature_settings_mocks_enabled` is OFF, redirects to
 * `/settings` so the route effectively does not exist for the user. This
 * is a UX guard, not a security boundary — mocked sections render no real
 * data, so the cost of the gate being briefly evaluated client-side is nil.
 */
const RequireMocksGate: React.FC<RequireMocksGateProps> = ({ children }) => {
  const mocksEnabled = useGateValue('feature_settings_mocks_enabled');

  if (!mocksEnabled) {
    return <Navigate to="/settings" replace />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default RequireMocksGate;
